module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Demo Reivew",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one: Class performance  :")]), _vm._v(" "), _c('h4', [_vm._v("\n        Student's overal performance in English learning(must include the student's strengths and weaknesses in listening/speaking/reading/writing/grammar etc, no less than 30 words in total)\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)]), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two： Learning Suggestions :")]), _vm._v(" "), _c('p', [_vm._v("\n        The demo level is  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.word1),
      expression: "formData.word1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.word1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "word1", $event.target.value)
      }
    }
  }), _vm._v(" (a bit difficult/a perfect fit/a bit easy) for the\n        student, so I suggest starting your English journey from "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.word2),
      expression: "formData.word2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.word2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "word2", $event.target.value)
      }
    }
  }), _vm._v("(a particular level that \n        we have) and taking classes twice or three times a week to ensure a great learning outcome.\n        Overall, I am very pleased with our first class together. You did a wonderful job\n        participating the class activities and  I look forward to seeing you again soon in the\n        classroom.\n      ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5427c6e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/StudentWriteReviewDemoModal.vue
// module id = 1816
// module chunks = 8